import { HttpTypes } from '@medusajs/types';

/** True if at least one variant of the product currently benefits from an active promotion (calculated price below original price). */
export const productHasActivePromotion = (product: HttpTypes.StoreProduct): boolean => {
  return !!product.variants?.some((variant) => {
    const calculated = variant.calculated_price?.calculated_amount;
    const original = variant.calculated_price?.original_amount;
    return calculated != null && original != null && calculated < original;
  });
};
